module.exports = __webpack_public_path__ + "static/img/show1.d3508bcb.png";